module.exports = __webpack_public_path__ + "static/media/icon-en.d0b21d3f.svg";